import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'components/Modal';
import InviteUserForm from './components/InviteUserForm';
import InviteUserHeader from './components/InviteUserHeader';
import DomoFooterLogo from 'components/DomoFooterLogo';

class InviteUserModal extends React.Component {
  handleSend = () => {
    this.props.onRequestModalClose();
    this.props.onSend && this.props.onSend();
  };

  close = () => {
    this.props.onRequestModalClose();
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onOpen={this.props.onOpen}
        icon={<noscript />}
      >
        <InviteUserHeader onSend={this.handleSend} onCancel={this.close} />
        <InviteUserForm />
        <DomoFooterLogo />
      </Modal>
    );
  }
}

InviteUserModal.propTypes = {
  onOpen: PropTypes.func,
  onSend: PropTypes.func,
};

export default InviteUserModal;
